/**
 * Compuerta de permiso de la campana de notificaciones.
 *
 * La campana del SSR solo se mostraba a mostrador/supervisor/admin; en la SPA se
 * muestra a quien tiene `view_pedidos_laminas` (el mismo permiso que exige el
 * endpoint). Este wrapper decide la visibilidad para que el `NotificationsBell` (y
 * su polling) NO se monte sin permiso: así no se sondea un dato que el actor no
 * debe ver, reproduciendo la visibilidad del SSR (`docs/frontend_architecture.md`,
 * Pr. 5). Sin permiso, no renderiza nada.
 */
import { useAuth } from "@/lib/auth";

import { NOTIFICATIONS_PERMISSION } from "../constants";

import { NotificationsBell } from "./NotificationsBell";

export function NotificationsBellGate() {
  const { hasPermission } = useAuth();

  if (!hasPermission(NOTIFICATIONS_PERMISSION)) {
    return null;
  }
  return <NotificationsBell />;
}
